"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikFormattedDatePicker = exports.disableWeekends = exports.ViewsDatePicker = exports.FormattedDatePicker = exports.DatePicker = exports.ViewsDatePickerArgs = exports.FormattedDatePickerArgs = exports.DatePickerArgs = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_date_picker_1 = require("./il-date-picker");
var date_fns_1 = require("date-fns");
// arguments
exports.DatePickerArgs = {
    value: '',
    renderInput: function (inputProps) { return react_1.default.createElement(material_1.TextField, __assign({}, inputProps, { size: "small", helperText: null })); },
};
exports.FormattedDatePickerArgs = __assign(__assign({}, exports.DatePickerArgs), { inputFormat: 'EE, LLL dd yyyy', label: 'Date picker', disableMaskedInput: true });
exports.ViewsDatePickerArgs = __assign(__assign({}, exports.DatePickerArgs), { label: 'Date picker', views: [enums_1.DatePickerViewsEnum.MONTH] });
// components
exports.DatePicker = (0, get_component_1.getComponent)(il_date_picker_1.ILDatePicker, exports.DatePickerArgs);
exports.FormattedDatePicker = (0, get_component_1.getComponent)(il_date_picker_1.ILDatePicker, exports.FormattedDatePickerArgs);
exports.ViewsDatePicker = (0, get_component_1.getComponent)(il_date_picker_1.ILDatePicker, exports.ViewsDatePickerArgs);
var disableWeekends = function (date) { return date.getDay() === 0 || date.getDay() === 6; };
exports.disableWeekends = disableWeekends;
function FormikFormattedDatePicker(_a) {
    var formik = _a.formik, id = _a.id, onChange = _a.onChange, _b = _a.dateFunction, dateFunction = _b === void 0 ? date_fns_1.startOfDay : _b, value = _a.value, props = __rest(_a, ["formik", "id", "onChange", "dateFunction", "value"]);
    return (react_1.default.createElement(exports.FormattedDatePicker, __assign({ onChange: function (newDate) {
            formik.setFieldValue(id, dateFunction(newDate));
            onChange && onChange(newDate);
        }, value: formik.values[id] || value, InputAdornmentProps: {
            position: 'start',
        } }, props, { renderInput: function (inputProps) { return (react_1.default.createElement(material_1.TextField, __assign({}, inputProps, { id: id, size: enums_1.SizeEnum.SMALL, error: formik.touched[id] && Boolean(formik.errors[id]), helperText: react_1.default.createElement(react_1.default.Fragment, null, formik.touched[id] && formik.errors[id]), sx: {
                width: '100%',
            } }))); } })));
}
exports.FormikFormattedDatePicker = FormikFormattedDatePicker;
